import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Features Redux States
import {
  GET_FEATURES,
  GET_FEATURE,
  CREATE_FEATURE,
  EDIT_FEATURE,
  DELETE_FEATURE,
} from "./actionTypes";
import {
  setFeatures,
  apiError,
  setFeature,
  createFeatureSuccess,
  editFeatureSuccess,
  deleteFeatureSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getFeatures({ payload: { page, qnt, name, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/feature?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      yield put(setFeatures(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createFeature({ payload: { newFeatureValues } }) {
  try {
    const response = yield call(axios.post, `/feature`, newFeatureValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createFeatureSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getFeature({ payload: { idFeature, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/feature?${
        (idFeature ? `id=${idFeature}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.data
    ) {
      yield put(setFeature(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editFeature({ payload: { idFeature, newFeatureValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/feature?${idFeature ? `id=${idFeature}` : ""}`,
      newFeatureValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response?.data?.message
    ) {
      let message = response.data.message;
      yield put(editFeatureSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteFeature({ payload: { idFeature } }) {
  try {
    const response = yield call(
      axios.delete,
      `/feature${idFeature ? `?id=${idFeature}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteFeatureSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchFeature() {
  yield takeEvery(GET_FEATURES, getFeatures);
}
export function* watchGetFeature() {
  yield takeEvery(GET_FEATURE, getFeature);
}
export function* watchCreateFeature() {
  yield takeEvery(CREATE_FEATURE, createFeature);
}
export function* watchEditFeature() {
  yield takeEvery(EDIT_FEATURE, editFeature);
}
export function* watchDeleteFeature() {
  yield takeEvery(DELETE_FEATURE, deleteFeature);
}
function* authSaga() {
  yield all([
    fork(watchFeature),
    fork(watchGetFeature),
    fork(watchCreateFeature),
    fork(watchEditFeature),
    fork(watchDeleteFeature),
  ]);
}

export default authSaga;
